import { render, staticRenderFns } from "./ContactPlaces.vue?vue&type=template&id=f719ef0a&scoped=true&"
import script from "./ContactPlaces.vue?vue&type=script&lang=js&"
export * from "./ContactPlaces.vue?vue&type=script&lang=js&"
import style0 from "./ContactPlaces.vue?vue&type=style&index=0&id=f719ef0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f719ef0a",
  null
  
)

export default component.exports